<template>
    <!-- 除了HPC外的内置产品申请页 -->
    <div class="apply-container">
        <!-- header 部分 -->
        <portal-header :transparent='false'></portal-header>
        <div class="apply-layout">
            <div class="placeholder"
                 style="height:50px;"></div>
            <div class="apply-div">
                <div class="apply-title">
                    <span v-if="serviceData.productCode">{{$t('购买')}} - {{$t(productName)}}&nbsp;{{['ModelArts','DRP','IAAS'].includes(serviceData.productCode)?'': serviceData.productCode}}</span>
                </div>
                <div v-if="serviceData.productCode && serviceData.productCode!=='ModelArts'"
                     class="stepbar-div">
                    <stepbar :steps="steps"
                             class="no-shadow"
                             :current="step"></stepbar>
                </div>
                <div class="hint certification"
                     v-if="isAuthentStatus">
                    <i class="icon-prompt-1-o"></i>
                    <div class="hintFont">
                        <p>{{$t(`您尚未${authTypeName}认证，开通服务需要先进行${authTypeName}认证。`)}}<span @click="certificationFun">{{$t('立即认证')}}</span>&nbsp;&nbsp;{{$t(`若已提交${authTypeName}认证，审核将会在1-2天内完成，请耐心等待。`)}}</p>
                    </div>
                </div>
                <div class="apply-content">
                    <!-- 介绍 -->
                    <div class="top-productDesc"
                         v-if="serviceData&&serviceData.productCode">
                        <div class="left">
                            <img src="@/assets/images/console/modelarts1.png" />
                        </div>
                        <div class="right"
                             v-if="serviceData&&serviceData.productCode&&['ModelArts','DRP','IAAS'].includes(serviceData.productCode)">
                            <p>{{$t('ModelArts 是面向开发者的一站式 AI 平台，为机器学习与深度学习提供海量数据预处理及交互式智能标注、大规模分布式训练、自动化模型生成，及端-边-云模型按需部署能力，帮助用户快速创建和部署模型，管理全周期 AI 工作流。专属资源池为专业用户提供高性能，高效率的优化体验，资源池支持包周期计费，满足不同专业用户需求。')}}</p>
                        </div>
                        <div class="right"
                             v-else>
                            <p> {{$t(productName)}}&nbsp;{{['ModelArts','DRP','IAAS'].includes(serviceData.productCode)?'': serviceData.productCode}}</p>
                        </div>
                    </div>
                    <Form ref="baseForm"
                          v-if="!step"
                          v-show="this.serviceData.productCode && !['ModelArts'].includes(this.serviceData.productCode)"
                          :model="baseForm"
                          label-position='left'
                          :label-width="labelWidth"
                          :rules="rules"
                          :label-colon="true"
                          class="bg-white"
                          style="padding: 20px 0 1px 40px;">
                        <FormItem v-show="!['DRP'].includes(this.serviceData.productCode)"
                                  :label="$t('所属项目')"
                                  prop="projectId">
                            <Select style="width:300px"
                                    v-if="!step"
                                    @on-change="changeProject"
                                    v-model="baseForm.projectId">
                                <Option v-for="(item, index) in projectDataList"
                                        :key="index"
                                        :value="item.orgSid+''">{{item.orgName}}</Option>
                            </Select>
                            <div class="instruction">
                                <p>{{$t('所属项目可以通过控制台进行创建，如无创建项目系统将该资源挂靠默认项目中。')}}</p>
                            </div>
                        </FormItem>
                        <FormItem :label="$t('资源名称')"
                                  prop="name"
                                  v-if="serviceData.productCode&&['DRP','IAAS'].includes(serviceData.productCode)">
                            <Input :placeholder="$t('请输入')+$t('名称')"
                                   v-model="baseForm.name"
                                   style="width:300px;" />
                            <div class="instruction">
                                <p>{{$t('4-30个字符，只能以小写字母开头，由小写字母、数字、中划线(-)组成，不能以中划线结尾。')}}</p>
                            </div>
                        </FormItem>
                    </Form>
                    <!-- 服务组件 -->
                    <div v-if="loading"
                         class="custom-loading">
                        <loading :size="24"></loading>
                    </div>
                    <div v-else
                         class="components bg-white"
                         style="padding-bottom:1px;">
                        <!-- 申请 -->
                        <keep-alive v-if="step == 0 || isModelArts">
                            <inner v-if="(!step || isModelArts)  && (serviceData.serviceComponent=='innerService'||serviceData.serviceComponent=='sefService')"
                                   :panelDataList="templateConfig.panelDataList"
                                   :configs="templateConfig.configs"
                                   :templateType='templateType'
                                   :priceData="priceData"
                                   @inquiry="inquiryPrice"
                                   ref="innerService"></inner>
                            <p v-else
                               style="text-align: center;padding:70px 15px; border-top: 10px solid #f5f6f7;color:#515a6e;">
                                <img src="@/assets/images/console/error.png"
                                     width="25"
                                     style="vertical-align: middle;margin-top: -5px;margin-right: 3px;" /> {{$t('产品信息加载失败，请联系平台管理人员！')}}
                            </p>
                        </keep-alive>
                        <!-- 确认信息 -->
                        <confirm v-if="step == 1 && !isModelArts"
                                 :component="serviceData.serviceComponent"
                                 :templateType='templateType'
                                 :priceData="priceData"
                                 :submitData="submitData"
                                 :baseForm="baseForm"
                                 :notBilled="notBilled"
                                 :pflopsText="pflopsText"
                                 @inquiry="inquiryPrice"></confirm>
                    </div>
                </div>
            </div>
        </div>
        <div class="apply-footer"
             v-if="serviceData.productCode">
            <div class="footer-div">
                <div class="balance">
                    <span class="config">
                        <inquiry-price ref="inquiryPrice"
                                       v-if="templateType!=null"
                                       :templateType="templateType"
                                       @notBilled="(status) => notBilled=status"></inquiry-price>
                    </span>
                    <div class="tips"
                         :title="$t('此为参考价格，具体扣费请以账单为准。扣费优先级为优惠券>抵扣现金券>充值现金券余额>现金余额>信用额度。')">{{$t('此为参考价格，具体扣费请以账单为准。扣费优先级为优惠券>抵扣现金券>充值现金券余额>现金余额>信用额度。')}}</div>
                </div>
                <div class="btn-div">
                    <Button v-if="step == 0 && !isModelArts"
                            type="primary"
                            @click="gotoNext(1)">{{$t('下一步')}}</Button>
                    <Button v-if="step == 1 &&  !isModelArts"
                            type="default"
                            @click="gotoNext(0)"
                            class="mar-right15">{{$t('上一步')}}</Button>
                    <Button v-if="step == 1 || isModelArts"
                            type="primary"
                            :disabled="!isBtnShow || isFreezeStatus||isModelArtsFreezeStatus"
                            :loading="submitLoading"
                            @click="submit">
                        <span v-if="isFreezeStatus||isModelArtsFreezeStatus">{{$t('用户已冻结')}}</span>
                        <span v-else>{{submitLoading? $t('提交中') : $t('立即购买')}}</span>
                    </Button>
                </div>
            </div>
        </div>
        <!--倒计时-->
        <countdown ref="countdown"
                   :txt="msg"
                   :jumpTxt="$t('我的订单')"
                   jumpLink="/mgt/order"
                   width='500'>
        </countdown>
    </div>
</template>

<script>
import countdown from '@c/basic/countdown'
import API from '@/service/api.js'
import { chargeInnerService, notComponet } from '@/service/innerService.js'
import portalHeader from '@c/portal/header'
import loading from '@c/basic/loading'
import inner from './components/inner/index.vue'
import confirm from './components/confirm'
import inquiryPrice from '@c/console/inquiry-price'
import innerServiceMixin from '@/mixin/innerServiceMixin.js'
import stepbar from '@/views/components/basic/stepbar'
export default {
    name: 'ApplyProduct',
    components: {
        portalHeader,
        loading,
        inquiryPrice,
        confirm,
        inner,
        countdown,
        stepbar
    },
    data () {
        return {
            steps: [
                { name: this.$i18n.t('基础配置'), step: 0 },
                { name: this.$i18n.t('配置信息'), step: 1 }
            ],
            isBtnShow: true,
            loading: true,
            submitLoading: false,
            productName: null,
            serviceData: {
                serviceId: this.$route.params.id,
                serviceName: null,
                serviceComponent: null,
                templateId: null,
                productCode: null
            },
            obsId: 0,
            typeList: {
                OBS: '对象存储 OBS',
                'ECS-X86': '云主机 ECS',
                EVS: '云硬盘 EVS',
                VPC: '虚拟私有云 VPC',
                VPN: '虚拟专用网络 VPN',
                'EIP-INNER': '弹性公网IP EIP',
                DC: '云专线 DC',
                IMS: '镜像服务 IMS',
                CBR: '云备份 CBR',
                ELB: '弹性负载均衡 ELB',
                CES: '云监控服务 CES',
                SWR: '容器镜像服务 SWR',
                DRP: '昇腾ModelArts专属资源池',
                ModelArts: '昇腾ModelArts共享资源池 ',
                IAAS: '昇腾IAAS专属云服务',
                'SFS2.0': '弹性文件服务',
                HPC: 'HPC共享资源池',
                'HPC-DRP': 'HPC专属资源池'
            },
            envDataList: [],
            selectedEnvSid: null,
            projectDataList: [], // 项目
            templateConfig: null, // 内置服务配置
            step: 0,
            inquiryFlag: null,
            inputsData: [],
            templateType: null,
            submitData: { // 表单数据
                tradePrice: null,
                price: null,
                fixedPrice: null,
                zeroData: null,
                projectData: {},
                templatesData: {},
                oneData: {
                    count: 1,
                    time: 1,
                    isCoupon: false,
                    couponId: null,
                    discount: null
                }
            },
            priceData: [],
            modelArtsServiceid: null,
            obsServiceid: null,
            baseForm: {
                projectId: null, // 项目Id
                name: null // 名称
            },
            rules: {
                projectId: { required: true, message: this.$t('该字段不能为空'), trigger: 'blur' },
                name: [
                    { required: true, message: this.$t('该字段不能为空'), trigger: 'blur' },
                    { pattern: '^[a-z][a-z0-9-]{2,28}[a-z0-9]$', message: this.$t('4-30个字符，只能以小写字母开头，由小写字母、数字、中划线(-)组成，不能以中划线结尾。'), trigger: 'blur' },
                    {
                        trigger: 'blur',
                        validator: async (rule, value, callback) => {
                            const count = await this.checkName(value)
                            if (count) {
                                callback(new Error(this.$t('名称重复，请重新输入！')))
                            }
                        }
                    }
                ]
            },
            authType: this.$store.state.user.currentUser.info.authType,
            notBilled: false,
            pflopsText: ''
        }
    },
    computed: {
        isModelArts () {
            return this.serviceData.productCode === 'ModelArts'
        },
        isFreezeStatus () {
            return this.$store.state.user.currentUser.isFreezeStatus
        },
        isModelArtsFreezeStatus () {
            // ModelArts是否冻结
            return this.$store.state.user.currentUser.isModelArtsFreezeStatus
        },
        isAuthentStatus () {
            const userAuth = this.$store.state.user.currentUser.info.authentStatus
            const comAuth = this.$store.state.user.currentOrg.certificationStatus
            const flag = this.authType === 'company' ? comAuth !== 'authSucceed' : userAuth !== 'authSucceed'
            return flag
        },
        authTypeName () {
            return this.authType === 'company' ? '企业' : '实名'
        },
        UserSid () {
            return this.$store.state.user.currentUser.info.userSid
        },
        labelWidth () {
            return this.templateConfig ? this.templateConfig.configs.labelWidth > 160 ? this.templateConfig.configs.labelWidth : 160 : 160
        },
        labelPositon () {
            return this.templateConfig ? this.templateConfig.configs.labelPositon : 'right'
        },
        userAccount () {
            const userData = this.$store.state.user.currentUser.info || {}
            return userData.account
        },
        msg () {
            return `${this.userAccount}，${this.$t('请您耐心等待审核。若有问题，可通过工单联系运营管理员进行处理')}`
        }
    },
    mixins: [innerServiceMixin],
    created () {
        this.init()
        this.getProject()
        // this.getObsServiceId()
    },
    methods: {
        /**
         * 验证ma是否重名
         */
        checkName (name) {
            const url = `${API.GET_MA_CHECK}${encodeURIComponent(name)}`
            return new Promise((resolve, reject) => {
                this.axios.get(this.urlFormat(url, false)).then(res => {
                    resolve(res)
                }).catch((e) => {
                    reject(new Error('服务异常，请刷新重试！'))
                })
            })
        },
        certificationFun () {
            const path = this.authType === 'company' ? '/mgt/authent/company' : '/mgt/authent?id=' + this.UserSid
            this.$router.push({
                path
            })
        },
        getModelArtsPrice () {
            this.axios.all([this.getService(), this.getEnvt()]).then(this.axios.spread((productList, allEvn) => {
                this.productList = productList.dataList ? productList.dataList : productList
                if (allEvn && allEvn.length > 0) {
                    for (const i in allEvn) {
                        if (allEvn[i].cloudEnvType === 'HCSO') {
                            this.selectedEnvSid = allEvn[i].id
                            break
                        }
                    }
                }
                this.getPrice()
                this.loading = false
            }))
        },
        getService () {
            return this.axios.get(this.urlFormat(API.GET_PRODUCTS, false), {
                params: { nameLike: null }
                // headers: {
                //     noAuth: true,
                //     showMsg: false
                // }
            })
        },
        getPrice () {
            const { productCode } = this.serviceData
            this.productList.forEach(element => {
                if (element.serviceType === 'OBS') {
                    this.obsServiceid = element.id
                    this.obsId = element.id
                }
                if (element.serviceType === productCode) {
                    this.modelArtsServiceid = element.id
                }
            })
            const chargeItemCategory = ['DRP', 'IAAS'].includes(productCode) ? 'compute' : 'enterpriseIntelligence'
            const modelArtsData = {
                orderType: 'apply-other_service',
                projectId: this.baseForm.projectId,
                couponId: null,
                productInfo: [
                    {
                        billingAccountId: '',
                        productCode,
                        cloudEnvId: this.selectedEnvSid,
                        serviceId: this.modelArtsServiceid,
                        chargeType: 'PostPaid',
                        amount: 1,
                        priceUnit: 'Hour',
                        period: 1,
                        data: {
                            [productCode]: {
                                chargeItemCategory,
                                productCode,
                                unitPriceDisplay: true,
                                allSpecDisplay: true,
                                size: 1
                            }
                        }
                    },
                    {
                        billingAccountId: '',
                        productCode: 'OBS',
                        cloudEnvId: this.selectedEnvSid,
                        serviceId: this.obsServiceid,
                        chargeType: 'PostPaid',
                        amount: 1,
                        priceUnit: 'Hour',
                        period: 1,
                        data: {
                            obs: {
                                chargeItemCategory: 'blockStorage',
                                productCode: 'OBS',
                                unitPriceDisplay: true,
                                allSpecDisplay: true,
                                size: 1
                            }
                        }
                    }
                ]
            }
            this.axios.post(this.urlFormat(API.POST_BILLING_PRICE, false),
                modelArtsData
            ).then(res => {
                this.priceData = res || []
            })
        },
        getEnvt () {
            return this.axios.get(this.urlFormat(API.GET_INNERSERVER_ENVS), {
                params: {
                    ignoreDataFilter: true
                }
            })
        },
        init () {
            // 获取服务相关数据
            this.loading = true
            this.axios.get(this.urlFormat(API.GET_SERVICE_INFO + '/' + this.$route.params.id, true)).then(res => {
                if (res) {
                    // 服务基本信息
                    this.templateType = res.template.templateType
                    this.productName = res.productName || ''
                    this.serviceData.serviceName = res.template.templateName
                    this.serviceData.serviceComponent = res.serviceComponent
                    this.serviceData.templateId = res.template.id
                    this.serviceData.productCode = res.serviceComponent === 'innerService' ? res.serviceType : res.productCode
                    // 获取modelArts价格
                    if (['IAAS', 'DRP', 'ModelArts'].includes(this.serviceData.productCode)) {
                        this.getModelArtsPrice()
                    } else {
                        // 获取云环境
                        this.innerServiceEvns()
                    }
                    // 模板配置解析
                    this.templateConfig = this.$isNullOrEmpty(res.template.templateContent) ? null : JSON.parse(res.template.templateContent)
                }
            })
        },
        innerServiceEvns () {
            this.axios.get(this.urlFormat(API.GET_INNERSERVER_ENVS), {
                params: {
                    ignoreDataFilter: true
                }
            }).then(res => {
                this.loading = false
                if (res) {
                    if (res && res.length > 0 && (['Modelarts', 'DRP', 'IAAS', 'HPC', 'HPC-SAAS'].includes(this.serviceData.productCode))) {
                        // Modelarts与专属资源池\hpc走HCSO环境
                        for (const i in res) {
                            if (res[i].cloudEnvType === 'HCSO') {
                                this.selectedEnvSid = res[i].id
                                break
                            }
                        }
                    } else {
                        this.selectedEnvSid = res[0].id || null
                    }
                    this.$nextTick(() => {
                        this.$refs.innerService && this.$refs.innerService.inquiry(true)
                    })
                }
            })
        },
        // 查询项目
        getProject (templateId) {
            if (this.$store.state.user.currentUser.info.userSid) {
                this.axios.get(this.urlFormat(API.GET_ACCESS_POLICES_ID_PROJECT, false, [this.$store.state.user.currentUser.info.userSid])).then(res => {
                    if (res) {
                        this.projectDataList = res
                        if (this.projectDataList.length > 0) {
                            this.baseForm.projectId = this.projectDataList[0].orgSid + ''
                            this.submitData.projectData = this.projectDataList[0]
                        }
                    }
                })
            }
        },
        changeProject () {
            for (let i = 0; i < this.projectDataList.length; i++) {
                if ((this.projectDataList[i].orgSid + '') === this.baseForm.projectId) {
                    this.submitData.projectData = this.projectDataList[i]
                }
            }
        },
        gotoNext (val) {
            return new Promise((resolve, reject) => {
                if (val === 1) {
                    this.pflopsText = this.$refs.innerService.pflopsText
                    // 检验资源组件
                    const stepZeroData = this.$refs.innerService.validate();
                    (this.$refs.baseForm && this.$refs.baseForm.validate((v) => {
                        if (v) {
                            stepZeroData.valid.then((valid) => {
                                if (valid) {
                                    if (this.$store.state.user.currentUser.info.parentSid && this.$store.state.user.currentUser.info.parentSid !== null) {
                                        this.$Message.error(this.$t('子用户无开通权限！'))
                                    } else {
                                        const computingPower = (this.submitData && this.submitData.zeroData && this.submitData.zeroData.computingPower) || null
                                        this.submitData.zeroData = stepZeroData.data || {}
                                        this.submitData.zeroData.computingPower = computingPower
                                        this.submitData.templatesData = this.templateConfig ? stepZeroData.configList.filter(item => !notComponet.includes(item.type)) : []
                                        this.step = val
                                        resolve(true)
                                    }
                                }
                            })
                        }
                    })) || resolve(true)
                } else {
                    this.step = val
                    resolve(true)
                }
            })
        },
        // 询价
        inquiryPrice (params, step, callback) {
            if (step === 'zero') {
                this.submitData.zeroData = params
            } else {
                this.submitData.oneData = params
            }
            // 组合参数
            const data = this.submitData.zeroData
            data.timeCount = this.submitData.oneData
            data.timeCount.conut = params.time
            data.serviceId = this.serviceData.serviceId
            data.productCode = this.serviceData.productCode
            data.projectId = this.baseForm.projectId
            data.category = params.category
            data.envId = this.selectedEnvSid
            data.chargeType = params.chargeType
            if (!data.envId) {
                return
            }
            if (params.isCoupon) {
                data.couponId = params.couponId || null
            } else {
                data.couponId = null
            }

            // 限流，防止询价过快
            if (!this.inquiryFlag) {
                this.inquiryFlag = setTimeout(() => {
                    this.inquiryFlag = null
                    if (this.$refs.inquiryPrice) {
                        this.$refs.inquiryPrice.inquiry(this.serviceData.serviceComponent, data, this.templateType)
                        this.isBtnShow = false
                        setTimeout(() => {
                            this.submitData.price = this.$refs.inquiryPrice.originalPrice
                            this.submitData.fixedPrice = this.$refs.inquiryPrice.fixedPrice
                            this.submitData.tradePrice = this.$refs.inquiryPrice.tradePrice
                            callback && callback()
                            if (this.$refs.inquiryPrice.canCharge) {
                                this.isBtnShow = true
                            }
                        }, 3000)
                    }
                }, 500)
            }
        },
        innerServiceParams (serviceConfig, type) {
            // 内置产品服务
            const subData = this.submitData.zeroData
            const currentConfigDesc = []
            for (const item of this.submitData.templatesData) {
                if (!['content', 'line', 'table'].includes(item.type)) {
                    if (this.dynamicVisible(item.rules.dynamicVisibleValue)) {
                        currentConfigDesc.push({
                            label: item.options.label,
                            attrKey: item.options.attrKey,
                            value: this._formatValue(item, subData)
                        })
                    }
                }
            }
            const data = {}
            // 内置产品价格 obs 专属资源池
            if (this.templateType === 'OBS') {
                data.price = this.$refs.inquiryPrice.obsprice
                data.obs = this.$refs.inquiryPrice.applyInquire
            } else if (['ModelArts', 'DRP', 'IAAS'].includes(this.templateType)) {
                data.price = this.$refs.inquiryPrice.dedicatedResourcePoolPrice
                data[this.templateType] = this.$refs.inquiryPrice.applyInquire
            }
            return { data, currentConfigDesc }
        },
        string_to_dataString (str) {
            const reg = /\${(.+?)}/
            return str.match(reg)[1]
        },
        _isDynamicString (str) {
            const reg = /^\${(.+?)}$/
            return reg.test(str)
        },
        dynamicVisible (value) {
            if (!value) {
                return true
            }
            if (value === 'fasle') {
                return false
            }
            // 打开了开关 这里获取函数内容
            const result = this._dynamicFun(value, this.submitData.zeroData, 'show', '$')
            return result
        },
        preventAction (script) {
            let result = false
            if (script.indexOf('=') > 0 && script.indexOf('==') < 0 && script.indexOf('===') < 0) {
                result = true
            }
            if (script.indexOf('delete') > 0) {
                result = true
            }
            return result
        },
        _dynamicFun (script, model, target, argsName) {
            if (!script) return false
            if (this.preventAction(script)) {
                throw new Error('不能进行该操作：' + script)
            } else {
                /* 如果script中含有${}, 就获取中间的字符串 */
                if (this._isDynamicString(script)) {
                    script = this.string_to_dataString(script)
                }
                const func = script.indexOf('return') >= 0 ? `{${script}}` : ` return (${script})`
                const args = Array.isArray(argsName) ? argsName : [argsName]
                const copyModel = Array.isArray(model) ? model : [model]
                // eslint-disable-next-line no-new-func
                const Fn = new Function(...args, func)
                let result = null
                try {
                    result = Fn(...copyModel)
                    if (result === 'undefined') {
                        throw new Error()
                    } else {
                        return result
                    }
                } catch {
                    throw new Error(`${script}获取失败，值为${result}, 请检查数据和对应模板配置!`)
                }
            }
        },
        _formatValue (item, subData) {
            if (item.options.defaultData) {
                const data = item.options.defaultData.filter(el => el.value === subData[item.options.attrKey])[0]
                if (['radio', 'select'].includes(item.type)) {
                    return data ? data.label : '--'
                }
                if (['calculation'].includes(item.type)) {
                    return data ? (data.type + '/' + data.specifications) : '--'
                }
            }
            if (item.options.attrKey === 'time') {
                return (subData[item.options.attrKey] && subData[item.options.attrKey].toString() + '月') || '--'
            }
            return (subData[item.options.attrKey] && subData[item.options.attrKey].toString()) || '--'
        },
        async submit () {
            const isStep1 = this.isModelArts ? await this.gotoNext(1) : true
            if (!isStep1) return
            const applyData = {
                type: 'apply',
                name: this.serviceData.serviceName,
                productName: this.baseForm.name,
                serviceId: this.serviceData.serviceId,
                projectId: this.baseForm.projectId,
                originalCost: this.submitData.price, // 原价
                extCost: this.submitData.fixedPrice, // 配置费用
                couponSid: this.submitData.oneData.couponId, // 优惠券SID
                details: []
            }
            // details数据
            applyData.details.push({
                serviceId: this.serviceData.serviceId,
                serviceAttr: null,
                quantity: this.submitData.zeroData.count || 1,
                chargeType: this.$isNullOrEmpty(this.submitData.zeroData.chargeData) ? this.serviceData.serviceComponent === 'compute' ? 'PrePaid' : 'PostPaid' : this.submitData.zeroData.chargeData.value,
                duration: this.submitData.zeroData.time,
                serviceConfig: null
            })
            // 不计费
            if (!chargeInnerService.includes(this.templateType)) {
                applyData.details[0].chargeType = 'None'
            }
            if (this.templateType === 'ModelArts') {
                applyData.details[0].chargeType = 'PostPaid'
            }
            // 将1、2步数据合并到一起
            const newData = this.submitData.zeroData
            newData.timeCount = this.submitData.oneData
            newData.serviceData = this.serviceData
            const serviceConfig = {
                desc: null,
                serviceId: this.serviceData.serviceId,
                projectId: this.baseForm.projectId,
                serviceName: this.serviceData.serviceName,
                serviceComponent: this.serviceData.serviceComponent,
                inputs: this.inputsData,
                configs: this.$converInsConfigData(newData)
            }

            applyData.details[0].serviceConfig = JSON.stringify(serviceConfig)
            applyData.originalPrice = this.$refs.inquiryPrice.originalPrice || 0
            applyData.tradePrice = this.$refs.inquiryPrice.tradePrice || 0
            applyData.tradeOncePrice = this.$refs.inquiryPrice.tradeOncePrice || 0
            applyData.tradeOncePrice = this.$refs.inquiryPrice.tradeOncePrice || 0
            applyData.discountDetails = this.$refs.inquiryPrice.discountDetails || []
            applyData.billingPrices = this.$refs.inquiryPrice.billingPrices || null
            applyData.projectId = this.baseForm.projectId// 所属项目
            // 组装参数
            const paramsData = this.innerServiceParams(serviceConfig, this.serviceData.serviceComponent)
            if (!paramsData) {
                return
            }
            const data = {
                orderType: 'apply',
                projectId: this.baseForm.projectId,
                couponId: applyData.couponSid,
                productInfo: [
                    {
                        productCode: this.serviceData.productCode,
                        cloudEnvId: this.selectedEnvSid,
                        serviceId: parseInt(this.$route.params.id),
                        regionId: serviceConfig.configs.zone,
                        chargeType: applyData.details[0].chargeType,
                        amount: applyData.details[0].quantity,
                        priceUnit: applyData.details[0].chargeType === 'PostPaid' ? 'Hour' : 'Month',
                        period: Number(applyData.details[0].duration || 1),
                        data: JSON.stringify(paramsData.data),
                        productConfigDesc: {
                            currentConfigDesc: JSON.stringify(paramsData.currentConfigDesc)
                        }
                    }
                ]
            }
            if (['DRP', 'IAAS', 'AI'].includes(this.serviceData.productCode)) {
                data.productName = this.baseForm.name
                data.productInfo[0].applyType = this.submitData.zeroData.applyType
                data.productInfo[0].computingPower = this.submitData.zeroData.computingPower
            }
            if (this.serviceData.productCode === 'ModelArts') {
                data.productInfo.push({
                    productCode: 'OBS',
                    cloudEnvId: this.selectedEnvSid,
                    serviceId: this.obsServiceid,
                    chargeType: 'PostPaid',
                    amount: 1,
                    priceUnit: 'Hour',
                    period: 1,
                    data: {
                        obs: {
                            chargeItemCategory: 'blockStorage',
                            productCode: 'OBS',
                            unitPriceDisplay: true,
                            allSpecDisplay: true,
                            size: 1
                        }
                    },
                    productConfigDesc: {}
                })
            }
            // 提交数据
            this.submitLoading = true
            this.axios.post(this.urlFormat(API.POST_SERVER_APPLY, false), data, { headers: { showMsg: false } }).then((result) => {
                if (result.status || result === 'SUCCESS') {
                    this.$refs.countdown.goChoicePeople(null)
                    this.submitLoading = false
                } else {
                    result.message && this.$Message.error({ content: result.message, duration: 5 })
                    this.submitLoading = false
                }
            }).catch(() => {
                this.submitLoading = false
            })
        }

    }
}
</script>
<style lang="less">
.apply-container {
    .ivu-select-selected-value {
        font-size: 12px !important;
    }
    .ivu-select-placeholder {
        font-size: 12px !important;
    }
}
.hint.certification i {
    color: #ff8400;
}
.hint.certification {
    background: rgba(255, 250, 238, 0.5);
    border-color: rgba(250, 224, 188, 1);
}
@import '~@/views/portal/application/create.less';
</style>>
<style lang="less" scoped>
.apply-container {
    width: 100%;
    height: 100%;
    overflow: hidden;
    .apply-layout {
        width: 100%;
        height: calc(~'100% - 60px');
        .hint.certification {
            width: 1200px;
            margin: 0 auto 15px auto;
            .hintFont {
                p {
                    span {
                        color: #ff8400;
                        font-weight: 500;
                        cursor: pointer;
                        text-decoration: underline;
                    }
                }
            }
        }
        .placeholder {
            width: 100%;
            height: 100px;
            background: black;
        }
        .apply-div {
            width: 100%;
            height: calc(~'100% - 50px');
            position: relative;
            overflow-y: auto;
            padding: 0px 0px 10px 0px;
            background: #f5f6f7;
            .apply-title {
                width: 100%;
                height: 50px;
                padding-left: 15px;
                line-height: 50px;
                margin: 0 auto;
                margin-bottom: 15px;
                background: #fff;
                font-weight: 600;
                font-size: 14px;
            }
            .apply-content {
                width: 1200px;
                margin: 0 auto;
                .instruction {
                    padding-top: 8px;
                    color: #999999;
                    line-height: 20px;
                }
                .top-productDesc {
                    width: 1200px;
                    margin: 0 auto;
                    background: #fff;
                    margin-bottom: 10px;
                    overflow: hidden;
                    display: flex;
                    .left,
                    .right {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        padding: 15px 40px 15px 0;
                    }
                    .left {
                        padding-top: 15px;
                        width: 200px;
                        text-align: center;
                        img {
                            width: 118px;
                            margin: 0 auto;
                        }
                    }
                    .right {
                        line-height: 24px;
                        width: calc(~'100% - 215px');
                    }
                }
                .bg-white {
                    background: #fff;
                }
                .custom-loading {
                    // padding-right: 300px;
                }
            }
        }
    }
    .apply-footer {
        width: 100%;
        height: 60px;
        background: #fff;
        margin: 0 auto;
        border-top: 1px solid #e9e9e9;
        .footer-div {
            width: 1100px;
            height: 100%;
            margin: 0 auto;
            display: flex;
            .balance {
                width: 700px;
                height: 100%;
                // line-height: 60px;
                margin-top: 10px;
                .config {
                    display: inline-block;
                    line-height: 20px;
                    width: 100%;
                }
                .tips {
                    line-height: 18px;
                    color: #999999;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
            .btn-div {
                width: calc(~'100% - 700px');
                height: 60px;
                line-height: 60px;
                text-align: right;
                padding-right: 4px;
            }
        }
    }
}
</style>
